export enum MultiselectLoader {
  circle = 'circle',
  button = 'button',
}

export type MultiselectLoaderType = 'circle' | 'button';
